declare namespace $ {

	type $shm_hitalama_textarea_code__text_shm_hitalama_textarea_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textarea['value'] >
		,
		ReturnType< $shm_hitalama_textarea_code['text'] >
	>
	type $shm_hitalama_textarea_code__render_visible_only_shm_hitalama_textarea_2 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_hitalama_textarea_code['render_visible_only'] >
	>
	type $shm_hitalama_textarea_code__row_numb_shm_hitalama_textarea_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textarea['row_numb'] >
		,
		ReturnType< $shm_hitalama_textarea_code['row_numb'] >
	>
	type $shm_hitalama_textarea_code__sidebar_showed_shm_hitalama_textarea_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textarea['sidebar_showed'] >
		,
		ReturnType< $shm_hitalama_textarea_code['sidebar_showed'] >
	>
	type $shm_hitalama_textarea_code__highlight_shm_hitalama_textarea_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textarea['highlight'] >
		,
		ReturnType< $shm_hitalama_textarea_code['highlight'] >
	>
	type $shm_hitalama_textarea_code__syntax_shm_hitalama_textarea_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textarea['syntax'] >
		,
		ReturnType< $shm_hitalama_textarea_code['syntax'] >
	>
	type $shm_hitalama_textarea_code__value_click_shm_hitalama_textarea_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textarea['value_click'] >
		,
		ReturnType< $shm_hitalama_textarea_code['value_click'] >
	>
	export class $shm_hitalama_textarea extends $mol_textarea {
		syntax( ): $mol_syntax2
		value_click( id: any, next?: any ): any
		View( ): $shm_hitalama_textarea_code
	}
	
	type $shm_hitalama_textarea_code_line__numb_showed_shm_hitalama_textarea_code_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textarea_code['sidebar_showed'] >
		,
		ReturnType< $shm_hitalama_textarea_code_line['numb_showed'] >
	>
	type $shm_hitalama_textarea_code_line__numb_shm_hitalama_textarea_code_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textarea_code['row_numb'] >
		,
		ReturnType< $shm_hitalama_textarea_code_line['numb'] >
	>
	type $shm_hitalama_textarea_code_line__theme_shm_hitalama_textarea_code_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textarea_code['row_theme'] >
		,
		ReturnType< $shm_hitalama_textarea_code_line['theme'] >
	>
	type $shm_hitalama_textarea_code_line__text_shm_hitalama_textarea_code_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textarea_code['row_text'] >
		,
		ReturnType< $shm_hitalama_textarea_code_line['text'] >
	>
	type $shm_hitalama_textarea_code_line__syntax_shm_hitalama_textarea_code_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textarea_code['syntax'] >
		,
		ReturnType< $shm_hitalama_textarea_code_line['syntax'] >
	>
	type $shm_hitalama_textarea_code_line__uri_resolve_shm_hitalama_textarea_code_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textarea_code['uri_resolve'] >
		,
		ReturnType< $shm_hitalama_textarea_code_line['uri_resolve'] >
	>
	type $shm_hitalama_textarea_code_line__value_click_shm_hitalama_textarea_code_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textarea_code['value_click'] >
		,
		ReturnType< $shm_hitalama_textarea_code_line['value_click'] >
	>
	type $shm_hitalama_textarea_code_line__highlight_shm_hitalama_textarea_code_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textarea_code['highlight'] >
		,
		ReturnType< $shm_hitalama_textarea_code_line['highlight'] >
	>
	export class $shm_hitalama_textarea_code extends $mol_text_code {
		value_click( id: any, next?: any ): any
		Row( id: any): $shm_hitalama_textarea_code_line
	}
	
	type $shm_hitalama_textarea_code_token_value__type_shm_hitalama_textarea_code_line_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textarea_code_line['token_type'] >
		,
		ReturnType< $shm_hitalama_textarea_code_token_value['type'] >
	>
	type $shm_hitalama_textarea_code_token_value__haystack_shm_hitalama_textarea_code_line_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textarea_code_line['token_text'] >
		,
		ReturnType< $shm_hitalama_textarea_code_token_value['haystack'] >
	>
	type $shm_hitalama_textarea_code_token_value__needle_shm_hitalama_textarea_code_line_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textarea_code_line['highlight'] >
		,
		ReturnType< $shm_hitalama_textarea_code_token_value['needle'] >
	>
	type $shm_hitalama_textarea_code_token_value__click_shm_hitalama_textarea_code_line_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_textarea_code_line['token_value_click'] >
		,
		ReturnType< $shm_hitalama_textarea_code_token_value['click'] >
	>
	export class $shm_hitalama_textarea_code_line extends $mol_text_code_line {
		token_value_click( id: any, next?: any ): any
		value_click( id: any, next?: any ): any
		Token_value( id: any): $shm_hitalama_textarea_code_token_value
	}
	
	export class $shm_hitalama_textarea_code_token_value extends $mol_text_code_token {
		click( next?: any ): any
		event( ): ({ 
			click( next?: ReturnType< $shm_hitalama_textarea_code_token_value['click'] > ): ReturnType< $shm_hitalama_textarea_code_token_value['click'] >,
		})  & ReturnType< $mol_text_code_token['event'] >
		attr( ): ({ 
			'role': string,
			'tabindex': string,
		})  & ReturnType< $mol_text_code_token['attr'] >
	}
	
}

//# sourceMappingURL=textarea.view.tree.d.ts.map